export const pusherChannels = {
  createAffiliateProduct: {
    name: 'create-affiliate-product',
    events: {
      affiliateProductCreated: {
        name: 'affiliate-product-created'
      }
    }
  }
}
